module.exports = __webpack_public_path__ + "6a82e69faafe84293d17d7e8c71b4f78.svg";